<template>
  <div v-html="html">
  </div>
</template>

<script>
import api from '@/plugins/api';
export default {
  name: "PaginaAvisoLegal",

  data: () => ({
    html: '',
    tipoPagina: 0
  }),

  watch: {
    // captura el cambio de idioma
    '$i18n.locale': function (val) {
      this.obtenerTerminosCondiciones(val);
    },

    // captura los cambios de parametros en la ruta si le llama esta pagina estando activa
    $route: function() {
      this.obtenerTerminosCondiciones(this.$i18n.locale.toUpperCase());
      window.scrollTo(0,0);
    }
  },

  methods: {
    obtenerTerminosCondiciones: function(idioma) {
      api.obtenerTerminosYCondicones(this.$route.params.tipoPagina,idioma)
        .then((res)=>{
          this.html = res.data.terminos.terminos.texto;
        })

      }  // fin ObtenerTerminosCondiciones


  },  // fin methods

  mounted () {
    // consulto al parking por el texto a presentar
    this.obtenerTerminosCondiciones(this.$i18n.locale.toUpperCase());
    window.scrollTo(0,0);

  },
   // fin evento mounted

};
</script>
